import React, { useMemo } from 'react';
import { Stack, Text } from '@chakra-ui/react';
import InvoiceItemCard from 'ts/common/components/invoice/InvoiceItemCard';
import { formatCurrencyValue } from 'ts/common/components/invoice/helpers';

interface Props {
    invoice: SpApi.Client.IInvoice;
}

const ClientInvoiceItemCardList: React.FC<Props> = ({ invoice }) => {
    const sortedItems = useMemo(
        () => [...invoice.items].sort((a, b) => a.displayOrder - b.displayOrder),
        [invoice.items]
    );

    return (
        <Stack spacing="12px">
            {sortedItems.map((item, index) => (
                <InvoiceItemCard
                    key={`item-${index}`}
                    name={item.name}
                    description={item.description ?? undefined}
                    leftBottomContent={
                        <Text fontSize="14px" color="gray.600">
                            Qty. {item.quantity}
                        </Text>
                    }
                    rightBottomContent={
                        <Text fontWeight="regular" fontSize="16px">
                            {formatCurrencyValue(item.totalPrice, invoice.currencyCode)}
                        </Text>
                    }
                />
            ))}
        </Stack>
    );
};

export default ClientInvoiceItemCardList;
